/**
 * `55` — *When an item is created*. Fires for items created by any means, an automation's own
 * `507` included, which is exactly why the depth limit and the self-retrigger rule exist.
 * Exports the creating user, which is what `1822` ("assign creator") consumes.
 */
import { z } from 'zod';
import { defineTrigger } from '../block.js';
export const itemCreatedParams = z.object({});
export const itemCreatedTrigger = defineTrigger({
    id: '55',
    kind: 'trigger',
    app: 'monday',
    sentencePartial: 'When an item is created',
    paramsSchema: itemCreatedParams,
    subscribes: ['item.created'],
    references: () => [],
    matches: () => true,
    outputs(event) {
        return {
            itemId: event.itemId,
            boardId: event.boardId,
            groupId: event.payload.groupId,
            userId: event.payload.createdBy ?? event.actorId,
        };
    },
});
//# sourceMappingURL=55.js.map